// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__E-YDW","form":"styles_form__LBQ6L","modal":"styles_modal__JLXHl","quill":"styles_quill__JDAZe"};